export interface Odd {
  Id: number;
  Active: boolean;
  Key: OddKey;
  OddFieldType: string;
  MultiLang: Record<string, string> | null;
  Value: number;
}

export enum OddKey {
  NONE = -1,
  OTHER = 0,
  ROM_1 = 1,
  ROM_X = 2,
  ROM_2 = 3,
  UO_O = 4,
  UO_U = 5,
  ROM_H1_1 = 6,
  ROM_H1_X = 7,
  ROM_H1_2 = 8,
  UO_H1_O = 9,
  UO_H1_U = 10,
  NG_1 = 11,
  NG_2 = 12,
  NG_X = 13,
  RESULT_1 = 20,
  RESULT_X = 21,
  RESULT_2 = 22,
  KICKOFF_1 = 23,
  KICKOFF_2 = 24,
  DNB_1 = 25,
  DNB_2 = 26,
  DC_1X = 27,
  DC_12 = 28,
  DC_X2 = 29,
  ROM_OT_1 = 30,
  ROM_OT_X = 31,
  ROM_OT_2 = 32,
  UO_OT_O = 33,
  UO_OT_U = 34,
  NG_OT_1 = 35,
  NG_OT_X = 36,
  NG_OT_2 = 37,
  PENALTY_1 = 38,
  PENALTY_2 = 39,
  HC_1 = 40,
  HC_X = 41,
  HC_2 = 42,
  TENNIS_MW_1 = 43,
  TENNIS_MW_2 = 44,
  TENNIS_SW_1 = 45,
  TENNIS_SW_2 = 46,
  TENNIS_GW_1 = 47,
  TENNIS_GW_X = 48,
  TENNIS_GW_2 = 49,
  TENNIS_RESULTS3_20 = 50,
  TENNIS_RESULTS3_21 = 51,
  TENNIS_RESULTS3_02 = 52,
  TENNIS_RESULTS3_12 = 53,
  TENNIS_RESULTS5_30 = 54,
  TENNIS_RESULTS5_31 = 55,
  TENNIS_RESULTS5_32 = 56,
  TENNIS_RESULTS5_03 = 57,
  TENNIS_RESULTS5_13 = 58,
  TENNIS_RESULTS5_23 = 59,
  TENNIS_SETS3_2 = 60,
  TENNIS_SETS3_3 = 61,
  TENNIS_SETS5_3 = 62,
  TENNIS_SETS5_4 = 63,
  TENNIS_SETS5_5 = 64,
  RESULT_H1_1 = 65,
  RESULT_H1_X = 66,
  RESULT_H1_2 = 67,
  HT_FT_11 = 68,
  HT_FT_X1 = 69,
  HT_FT_21 = 70,
  HT_FT_1X = 71,
  HT_FT_XX = 72,
  HT_FT_2X = 73,
  HT_FT_12 = 74,
  HT_FT_X2 = 75,
  HT_FT_22 = 76,
  CS_10 = 77,
  CS_20 = 78,
  CS_21 = 79,
  CS_30 = 80,
  CS_31 = 81,
  CS_32 = 82,
  CS_40 = 83,
  CS_41 = 84,
  CS_42 = 85,
  CS_43 = 86,
  CS_50 = 87,
  CS_51 = 88,
  CS_52 = 89,
  CS_00 = 90,
  CS_11 = 91,
  CS_22 = 92,
  CS_33 = 93,
  CS_44 = 94,
  CS_01 = 95,
  CS_02 = 96,
  CS_12 = 97,
  CS_03 = 98,
  CS_13 = 99,
  CS_23 = 100,
  CS_04 = 101,
  CS_14 = 102,
  CS_24 = 103,
  CS_34 = 104,
  CS_05 = 105,
  CS_15 = 106,
  CS_25 = 107,
  CS_06 = 108,
  CS_60 = 109,

  // NEW UOF CS
  CS_53 = 276,
  CS_54 = 277,
  CS_62 = 280,
  CS_35 = 278,
  CS_45 = 279,
  CS_17 = 284,
  CS_08 = 285,
  CS_26 = 283,
  CS_71 = 281,
  CS_80 = 282,

  CS_OTHER = 110,
  GNG_GOAL = 120,
  GNG_NOGOAL = 121,
  GHT_ZERO = 122,
  GHT_ONE = 123,
  GHT_TWO = 124,
  GHT_THREE_PLUS = 125,
  GAT_ZERO = 126,
  GAT_ONE = 127,
  GAT_TWO = 128,
  GAT_THREE_PLUS = 129,
  RESULT_OT_1 = 130,
  RESULT_OT_X = 131,
  RESULT_OT_2 = 132,
  WAY2_1 = 133,
  WAY2_2 = 134,
  PERIOD_WINNER_1 = 135,
  PERIOD_WINNER_X = 136,
  PERIOD_WINNER_2 = 137,
  RACE_X_POINTS_1 = 138,
  RACE_X_POINTS_2 = 139,
  SCORE_X_POINT_1 = 140,
  SCORE_X_POINT_2 = 141,
  TOTAL_GOALS_0_1 = 142,
  TOTAL_GOALS_2_3 = 143,
  TOTAL_GOALS_4_5 = 144,
  TOTAL_GOALS_6_PLUS = 145,
  TENNIS_UO_O = 146,
  TENNIS_UO_U = 147,
  NG_H1_1 = 148,
  NG_H1_2 = 149,
  NG_H1_X = 150,
  TENNIS_GAME_X_WINNER_1 = 151,
  TENNIS_GAME_X_WINNER_2 = 152,
  TENNIS_SET_UO_O = 153,
  TENNIS_SET_UO_U = 154,
  CS_16 = 155,
  CS_07 = 156,
  CS_61 = 157,
  CS_70 = 158,
  GOAL_ODD = 159,
  GOAL_EVEN = 160,
  GNG_H1_GOAL = 161,
  GNG_H1_NOGOAL = 162,
  FG15_1_15 = 163,
  FG15_16_30 = 164,
  FG15_31_45 = 165,
  FG15_46_60 = 166,
  FG15_61_75 = 167,
  FG15_76_90 = 168,
  FG15_NONE = 169,
  LG_1 = 170,
  LG_X = 171,
  LG_2 = 172,
  HSH_1 = 173,
  HSH_X = 174,
  HSH_2 = 175,
  RESULT_H2_1 = 176,
  RESULT_H2_X = 177,
  RESULT_H2_2 = 178,
  UO_H2_O = 179,
  UO_H2_U = 180,
  PSO_YES = 181,
  PSO_NO = 182,
  CORNER_W3_1 = 183,
  CORNER_W3_X = 184,
  CORNER_W3_2 = 185,
  CORNER_TOTAL_0_8 = 186,
  CORNER_TOTAL_9_11 = 187,
  CORNER_TOTAL_12_PLUS = 188,
  /// <summary>
  /// Way3_Under/Over - Tip 1/Over
  /// </summary>
  W3_UO_1O = 189,
  /// <summary>
  /// Way3_Under/Over - Tip 1/Over
  /// </summary>
  W3_UO_XO = 190,
  /// <summary>
  /// Way3_Under/Over - Tip 1/Over
  /// </summary>
  W3_UO_2O = 191,
  /// <summary>
  /// Way3_Under/Over - Tip 2/Under
  /// </summary>
  W3_UO_1U = 192,
  /// <summary>
  /// Way3_Under/Over - Tip 2/Under
  /// </summary>
  W3_UO_XU = 193,
  /// <summary>
  /// Way3_Under/Over - Tip 2/Under
  /// </summary>
  W3_UO_2U = 194,

  /// <summary>
  /// Tennis Correct Score for Set
  /// </summary>
  TENNIS_SET_CS_60 = 195,
  TENNIS_SET_CS_61 = 196,
  TENNIS_SET_CS_62 = 197,
  TENNIS_SET_CS_63 = 198,
  TENNIS_SET_CS_64 = 199,
  TENNIS_SET_CS_75 = 200,
  TENNIS_SET_CS_76 = 201,
  TENNIS_SET_CS_06 = 202,
  TENNIS_SET_CS_16 = 203,
  TENNIS_SET_CS_26 = 204,
  TENNIS_SET_CS_36 = 205,
  TENNIS_SET_CS_46 = 206,
  TENNIS_SET_CS_57 = 207,
  TENNIS_SET_CS_67 = 208,

  ADV_NXT_RND_1 = 209,
  ADV_NXT_RND_2 = 210,
  CS_H1_10 = 211,
  CS_H1_20 = 212,
  CS_H1_21 = 213,
  CS_H1_30 = 214,
  CS_H1_31 = 215,
  CS_H1_32 = 216,
  CS_H1_40 = 217,
  CS_H1_00 = 218,
  CS_H1_11 = 219,
  CS_H1_22 = 220,
  CS_H1_33 = 221,
  CS_H1_01 = 222,
  CS_H1_02 = 223,
  CS_H1_12 = 224,
  CS_H1_03 = 225,
  CS_H1_13 = 226,
  CS_H1_23 = 227,
  CS_H1_04 = 228,
  CS_H1_OTHER = 229,

  /// <summary>Handicap H1</summary>
  HC_H1_1 = 230,
  HC_H1_X = 231,
  HC_H1_2 = 232,

  /// <summary>Handicap H2</summary>
  HC_H2_1 = 233,
  HC_H2_X = 234,
  HC_H2_2 = 235,

  /// <summary>DoubleChance H1</summary>
  DC_H1_1X = 236,
  DC_H1_12 = 237,
  DC_H1_X2 = 238,

  /// <summary>DoubleChance H2</summary>
  DC_H2_1X = 239,
  DC_H2_12 = 240,
  DC_H2_X2 = 241,

  /// <summary>Total Goals Exact</summary>
  TOTAL_GOALS_EXACT_0 = 242,
  TOTAL_GOALS_EXACT_1 = 243,
  TOTAL_GOALS_EXACT_2 = 244,
  TOTAL_GOALS_EXACT_3 = 245,
  TOTAL_GOALS_EXACT_4 = 246,
  TOTAL_GOALS_EXACT_5 = 247,
  TOTAL_GOALS_EXACT_6_PLUS = 248,

  /// <summary>Total Goals Exact H1</summary>
  TOTAL_GOALS_EXACT_H1_0 = 249,
  TOTAL_GOALS_EXACT_H1_1 = 250,
  TOTAL_GOALS_EXACT_H1_2_PLUS = 251,

  /// <summary>Total Goals Exact H2</summary>
  TOTAL_GOALS_EXACT_H2_0 = 252,
  TOTAL_GOALS_EXACT_H2_1 = 253,
  TOTAL_GOALS_EXACT_H2_2_PLUS = 254,

  /// <summary>Under/Over Hometeam</summary>
  UO_HOMETEAM_O = 255,
  UO_HOMETEAM_U = 256,

  /// <summary>Under/Over Awayteam</summary>
  UO_AWAYTEAM_O = 257,
  UO_AWAYTEAM_U = 258,

  /// <summary>Under/Over corner</summary>
  UO_CORNER_O = 259,
  UO_CORNER_U = 260,

  /// <summary>Goal/NoGoal 2nd Half - Goal</summary>
  GNG_H2_GOAL = 261,
  /// <summary>Goal/NoGoal 2nd Half - NoGoal</summary>
  GNG_H2_NOGOAL = 262,

  /// <summary>Way 3 and Goal/NoGoal combination</summary>
  WAY_3_GNG_1_GOAL = 263,
  WAY_3_GNG_X_GOAL = 264,
  WAY_3_GNG_2_GOAL = 265,
  WAY_3_GNG_1_NOGOAL = 266,
  WAY_3_GNG_X_NOGOAL = 267,
  WAY_3_GNG_2_NOGOAL = 268,

  /// <summary>Under/Over and Goal/NoGoal combination</summary>
  UO_GNG_O_GOAL = 269,
  UO_GNG_U_GOAL = 270,
  UO_GNG_O_NOGOAL = 271,
  UO_GNG_U_NOGOAL = 272,

  /// <summary>Way 3 winner 10 minutes interval</summary>
  WAY_3_INT10_1 = 273,
  WAY_3_INT10_X = 274,
  WAY_3_INT10_2 = 275,
  OUTRIGHT_W_1 = 301,
  OUTRIGHT_W_2 = 302,
  OUTRIGHT_W_3 = 303,
  OUTRIGHT_W_4 = 304,
  OUTRIGHT_W_5 = 305,
  OUTRIGHT_W_6 = 306,
  OUTRIGHT_W_7 = 307,
  OUTRIGHT_W_8 = 308,
  OUTRIGHT_W_9 = 309,
  OUTRIGHT_W_10 = 310,
  OUTRIGHT_W_11 = 311,
  OUTRIGHT_W_12 = 312,
  OUTRIGHT_W_13 = 313,
  OUTRIGHT_W_14 = 314,
  OUTRIGHT_W_15 = 315,
  OUTRIGHT_W_16 = 316,
  OUTRIGHT_W_17 = 317,
  OUTRIGHT_W_18 = 318,
  OUTRIGHT_W_19 = 319,
  OUTRIGHT_W_20 = 320,
  OUTRIGHT_W_21 = 321,
  OUTRIGHT_W_22 = 322,
  OUTRIGHT_W_23 = 323,
  OUTRIGHT_W_24 = 324,
  OUTRIGHT_W_25 = 325,
  OUTRIGHT_W_26 = 326,
  OUTRIGHT_W_27 = 327,
  OUTRIGHT_W_28 = 328,
  OUTRIGHT_W_29 = 329,
  OUTRIGHT_W_30 = 330,
  OUTRIGHT_W_31 = 331,
  OUTRIGHT_W_32 = 332,
  OUTRIGHT_W_33 = 333,
  OUTRIGHT_W_34 = 334,
  OUTRIGHT_W_35 = 335,
  OUTRIGHT_W_36 = 336,
  OUTRIGHT_W_37 = 337,
  OUTRIGHT_W_38 = 338,
  OUTRIGHT_W_39 = 339,
  OUTRIGHT_W_40 = 340,
  OUTRIGHT_W_41 = 341,
  OUTRIGHT_W_42 = 342,
  OUTRIGHT_W_43 = 343,
  OUTRIGHT_W_44 = 344,
  OUTRIGHT_W_45 = 345,
  OUTRIGHT_W_46 = 346,
  OUTRIGHT_W_47 = 347,
  OUTRIGHT_W_48 = 348,
  OUTRIGHT_W_49 = 349,
  OUTRIGHT_W_50 = 350,
  OUTRIGHT_W_51 = 351,
  OUTRIGHT_W_52 = 352,
  OUTRIGHT_W_53 = 353,
  OUTRIGHT_W_54 = 354,
  OUTRIGHT_W_55 = 355,
  OUTRIGHT_W_56 = 356,
  OUTRIGHT_W_57 = 357,
  OUTRIGHT_W_58 = 358,
  OUTRIGHT_W_59 = 359,
  OUTRIGHT_W_60 = 360,
  OUTRIGHT_W_61 = 361,
  OUTRIGHT_W_62 = 362,
  OUTRIGHT_W_63 = 363,
  OUTRIGHT_W_64 = 364,
  OUTRIGHT_W_65 = 365,
  OUTRIGHT_W_66 = 366,
  OUTRIGHT_W_67 = 367,
  OUTRIGHT_W_68 = 368,
  OUTRIGHT_W_69 = 369,
  OUTRIGHT_W_70 = 370,
  OUTRIGHT_W_71 = 371,
  OUTRIGHT_W_72 = 372,
  OUTRIGHT_W_73 = 373,
  OUTRIGHT_W_74 = 374,
  OUTRIGHT_W_75 = 375,
  OUTRIGHT_W_76 = 376,
  OUTRIGHT_W_77 = 377,
  OUTRIGHT_W_78 = 378,
  OUTRIGHT_W_79 = 379,
  OUTRIGHT_W_80 = 380,
  OUTRIGHT_W_81 = 381,
  OUTRIGHT_W_82 = 382,
  OUTRIGHT_W_83 = 383,
  OUTRIGHT_W_84 = 384,
  OUTRIGHT_W_85 = 385,
  OUTRIGHT_W_86 = 386,
  OUTRIGHT_W_87 = 387,
  OUTRIGHT_W_88 = 388,
  OUTRIGHT_W_89 = 389,
  OUTRIGHT_W_90 = 390,
  OUTRIGHT_W_91 = 391,
  OUTRIGHT_W_92 = 392,
  OUTRIGHT_W_93 = 393,
  OUTRIGHT_W_94 = 394,
  OUTRIGHT_W_95 = 395,
  OUTRIGHT_W_96 = 396,
  OUTRIGHT_W_97 = 397,
  OUTRIGHT_W_98 = 398,
  OUTRIGHT_W_99 = 399,
  OUTRIGHT_W_100 = 400,
  OUTRIGHT_W_101 = 401,
  OUTRIGHT_W_102 = 402,
  OUTRIGHT_W_103 = 403,
  OUTRIGHT_W_104 = 404,
  OUTRIGHT_W_105 = 405,
  OUTRIGHT_W_106 = 406,
  OUTRIGHT_W_107 = 407,
  OUTRIGHT_W_108 = 408,
  OUTRIGHT_W_109 = 409,
  OUTRIGHT_W_110 = 410,
  OUTRIGHT_W_111 = 411,
  OUTRIGHT_W_112 = 412,
  OUTRIGHT_W_113 = 413,
  OUTRIGHT_W_114 = 414,
  OUTRIGHT_W_115 = 415,
  OUTRIGHT_W_116 = 416,
  OUTRIGHT_W_117 = 417,
  OUTRIGHT_W_118 = 418,
  OUTRIGHT_W_119 = 419,
  OUTRIGHT_W_120 = 420,
  OUTRIGHT_W_121 = 421,
  OUTRIGHT_W_122 = 422,
  OUTRIGHT_W_123 = 423,
  OUTRIGHT_W_124 = 424,
  OUTRIGHT_W_125 = 425,
  OUTRIGHT_W_126 = 426,
  OUTRIGHT_W_127 = 427,
  OUTRIGHT_W_128 = 428,
  OUTRIGHT_W_129 = 429,
  OUTRIGHT_W_130 = 430,
  OUTRIGHT_W_131 = 431,
  OUTRIGHT_W_132 = 432,
  OUTRIGHT_W_133 = 433,
  OUTRIGHT_W_134 = 434,
  OUTRIGHT_W_135 = 435,
  OUTRIGHT_W_136 = 436,
  OUTRIGHT_W_137 = 437,
  OUTRIGHT_W_138 = 438,
  OUTRIGHT_W_139 = 439,
  OUTRIGHT_W_140 = 440,
  OUTRIGHT_W_141 = 441,
  OUTRIGHT_W_142 = 442,
  OUTRIGHT_W_143 = 443,
  OUTRIGHT_W_144 = 444,
  OUTRIGHT_W_145 = 445,
  OUTRIGHT_W_146 = 446,
  OUTRIGHT_W_147 = 447,
  OUTRIGHT_W_148 = 448,
  OUTRIGHT_W_149 = 449,
  OUTRIGHT_W_150 = 450,
  OUTRIGHT_W_151 = 451,
  OUTRIGHT_W_152 = 452,
  OUTRIGHT_W_153 = 453,
  OUTRIGHT_W_154 = 454,
  OUTRIGHT_W_155 = 455,
  OUTRIGHT_W_156 = 456,
  OUTRIGHT_W_157 = 457,
  OUTRIGHT_W_158 = 458,
  OUTRIGHT_W_159 = 459,
  OUTRIGHT_W_160 = 460,
  OUTRIGHT_W_161 = 461,
  OUTRIGHT_W_162 = 462,
  OUTRIGHT_W_163 = 463,
  OUTRIGHT_W_164 = 464,
  OUTRIGHT_W_165 = 465,
  OUTRIGHT_W_166 = 466,
  OUTRIGHT_W_167 = 467,
  OUTRIGHT_W_168 = 468,
  OUTRIGHT_W_169 = 469,
  OUTRIGHT_W_170 = 470,
  OUTRIGHT_W_171 = 471,
  OUTRIGHT_W_172 = 472,
  OUTRIGHT_W_173 = 473,
  OUTRIGHT_W_174 = 474,
  OUTRIGHT_W_175 = 475,
  OUTRIGHT_W_176 = 476,
  OUTRIGHT_W_177 = 477,
  OUTRIGHT_W_178 = 478,
  OUTRIGHT_W_179 = 479,
  OUTRIGHT_W_180 = 480,
  OUTRIGHT_W_181 = 481,
  OUTRIGHT_W_182 = 482,
  OUTRIGHT_W_183 = 483,
  OUTRIGHT_W_184 = 484,
  OUTRIGHT_W_185 = 485,
  OUTRIGHT_W_186 = 486,
  OUTRIGHT_W_187 = 487,
  OUTRIGHT_W_188 = 488,
  OUTRIGHT_W_189 = 489,
  OUTRIGHT_W_190 = 490,
  OUTRIGHT_W_191 = 491,
  OUTRIGHT_W_192 = 492,
  OUTRIGHT_W_193 = 493,
  OUTRIGHT_W_194 = 494,
  OUTRIGHT_W_195 = 495,
  OUTRIGHT_W_196 = 496,
  OUTRIGHT_W_197 = 497,
  OUTRIGHT_W_198 = 498,
  OUTRIGHT_W_199 = 499,
  /// <summary>Over/Under Hometeam H1(Soccer) uofid=69        UNDER_OVER_HOMETEAM_H1 = 69 </ summary >
  UO_HOMETEAM_H1_O = 286,
  UO_HOMETEAM_H1_U = 287,

  /// <summary>Over/Under Awayteam H1(Soccer) uofid=70        UNDER_OVER_AWAYTEAM_H1 = 70 </ summary >
  UO_AWAYTEAM_H1_O = 288,
  UO_AWAYTEAM_H1_U = 289,

  /// <summary>Soccer - Matchbet and Total H1 (Combination of way3 and over/under: 1u, Xu, 2u, 1o, Xo, 2o) uofif=79        WAY_3_UNDER_OVER_H1 = 71 </ summary >
  W3_UO_H1_1O = 290,
  W3_UO_H1_XO = 291,
  W3_UO_H1_2O = 292,
  W3_UO_H1_1U = 293,
  W3_UO_H1_XU = 294,
  W3_UO_H1_2U = 295,

  /// <summary>Soccer - Matchbet and Both teams to score H1 (Combination of Way3 and both team to score) uofif=78        WAY_3_GOAL_NOGOAL_H1 = 72 </ summary >
  W3_GNG_H1_1_GOAL = 501,
  W3_GNG_H1_X_GOAL = 502,
  W3_GNG_H1_2_GOAL = 503,
  W3_GNG_H1_1_NOGOAL = 504,
  W3_GNG_H1_X_NOGOAL = 505,
  W3_GNG_H1_2_NOGOAL = 506,

  /// <summary>Soccer - Doublechance and Total  uofid=547        DOUBLE_CHANCE_UNDER_OVER = 73 </ summary >
  DC_UO_1X_O = 507,
  DC_UO_12_O = 508,
  DC_UO_X2_O = 509,
  DC_UO_1X_U = 510,
  DC_UO_12_U = 511,
  DC_UO_X2_U = 512,

  /// <summary>Soccer - Doublechance and both teams to score  uofid=546        DOUBLE_CHANCE_GOAL_NOGOAL = 74 </ summary >
  DC_GNG_1X_GOAL = 513,
  DC_GNG_12_GOAL = 514,
  DC_GNG_X2_GOAL = 515,
  DC_GNG_1X_NOGOAL = 516,
  DC_GNG_12_NOGOAL = 517,
  DC_GNG_X2_NOGOAL = 518,

  /// <summary>Over/Under in xth Period/Quarter (Basketball uofid=236, IceHockey  uofid=446)        UNDER_OVER_PERIOD = 75 </ summary >
  UO_PERIOD_O = 519,
  UO_PERIOD_U = 520,

  /// <summary>xth goal in xth Period (IceHockey  uofid=444)        XTH_GOAL_PERIOD = 76 </ summary >
  XTHG_PERIOD_1 = 521,
  XTHG_PERIOD_X = 522,
  XTHG_PERIOD_2 = 523,

  /// <summary>which team wins the rest in xth Period (IceHockey  uofid=458)        REST_OF_MATCH_PERIOD = 77 </ summary >
  ROM_PERIOD_1 = 524,
  ROM_PERIOD_X = 525,
  ROM_PERIOD_2 = 526,

  /// <summary> Which period has the most goals (IceHockey  uofid=432, 1s2, 2nd, 3rd, equal)        HIGHEST_SCORE_PERIOD = 78 </ summary >
  HSP_1 = 527,
  HSP_2 = 528,
  HSP_3 = 529,
  HSP_X = 530,
  /// <summary>UOF market id 33:  Competitor1 win to nil; WIN_TO_NIL_HOMETEAM = 82</summary>
  WTN_HT_YES = 531,
  WTN_HT_NO = 532,
  /// <summary>UOF market id 34:  Competitor2 win to nil; WIN_TO_NIL_HOMETEAM = 83</summary>
  WTN_AT_YES = 533,
  WTN_AT_NO = 534,
  /// <summary>UOF market id 50:  Competitor1 to win either half; WIN_EITHER_HALF_HOMETEAM = 84</summary>
  WEH_HT_YES = 535,
  WEH_HT_NO = 536,
  /// <summary>UOF market id 51:  Competitor2 to win either half; WIN_EITHER_HALF_AWAYTEAM = 85,</summary>
  WEH_AT_YES = 537,
  WEH_AT_NO = 538,
  /// <summary>UOF market id 56:  Competitor1 to score in both halves; GNG_BOTH_HALVES_HOMETEAM = 86</summary>
  GNG_BH_HT_YES = 539,
  GNG_BH_HT_NO = 540,
  /// <summary>UOF market id 57:  Competitor2 to score in both halves; GNG_BOTH_HALVES_AWAYTEAM = 87</summary>
  GNG_BH_AT_YES = 541,
  GNG_BH_AT_NO = 542,
  /// <summary>UOF market id 184: xth goal & 1x2; XTH_GOAL_WAY3 = 88</summary>
  XTHG_W3_HTGOAL_1 = 543,
  XTHG_W3_HTGOAL_X = 544,
  XTHG_W3_HTGOAL_2 = 545,
  XTHG_W3_ATGOAL_1 = 546,
  XTHG_W3_ATGOAL_X = 547,
  XTHG_W3_ATGOAL_2 = 548,
  XTHG_W3_NOGOOAL = 549,
  /// <summary>UOF market id 543: 2nd half - 1x2 & both teams to score; WAY_3_GNG_H2 = 89</summary>
  W3_GNG_H2_1_GOAL = 550,
  W3_GNG_H2_X_GOAL = 551,
  W3_GNG_H2_2_GOAL = 552,
  W3_GNG_H2_1_NOGOAL = 553,
  W3_GNG_H2_X_NOGOAL = 554,
  W3_GNG_H2_2_NOGOAL = 555,
  /// <summary>UOF market id 544: 2nd half - 1x2 & total; WAY_3_UNDER_OVER_H2 = 90,</summary>
  W3_UO_H2_1O = 556,
  W3_UO_H2_XO = 557,
  W3_UO_H2_2O = 558,
  W3_UO_H2_1U = 559,
  W3_UO_H2_XU = 560,
  W3_UO_H2_2U = 561,

  UO_CORNER_HT_O = 562,
  UO_CORNER_HT_U = 563,
  UO_CORNER_AT_O = 564,
  UO_CORNER_AT_U = 565,
  UO_CORNER_H1_O = 566,
  UO_CORNER_H1_U = 567,

  MS_10_20_30 = 568,
  MS_01_02_03 = 569,
  MS_40_50_60 = 570,
  MS_04_05_06 = 571,
  MS_21_31_41 = 572,
  MS_12_13_14 = 573,
  MS_32_42_43_51 = 574,
  MS_23_24_34_15 = 575,
  MS_OTHER_HOMETEAM = 576,
  MS_OTHER_AWAYTEAM = 577,
  MS_DRAW = 578,

  W3_OR_W3H1_1 = 579,
  W3_OR_W3H1_X = 580,
  W3_OR_W3H1_2 = 581,
  W3_XUP_1 = 582,
  W3_XUP_X = 583,
  W3_XUP_2 = 584,
}
